import React, { useEffect, useState, useRef } from 'react';
import styles from './detailsBox.module.scss';
import timeIcon from '../../../assets/icons/programs/major/timeStamp.svg';
import calendarIcon from '../../../assets/icons/programs/major/calendar.svg';
import studentIcon from '../../../assets/icons/programs/major/student.svg';
import policeManIcon from '../../../assets/Imagess/policeMan.svg';

import languageIcon from '../../../assets/icons/programs/major/languages.svg';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import Separator from '../../Atoms/separator/Separator';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import ApplicantsTab from '../../Atoms/Tabs/InfoTab';
import facilityIcon from '../../../assets/Imagess/facility.svg';
import researchIcon from '../../../assets/Imagess/research.svg';

import emailIcon from '../../../assets/Imagess/GreenEmail.svg';
import phoneIcon from '../../../assets/Imagess/GreenPhone.svg';
import AttachmentsIcon from '../../../assets/Imagess/AttachmentsIcon.svg';
import FormIcon from '../../../assets/Imagess/FormIcon.svg';

import InfoButton from '../../Atoms/InfoButton/InfoButton';
import InfoCard from '../../Atoms/Cards/InfoCard';
import { useNavigate } from 'react-router-dom';
import BackIcon from '../../../assets/Imagess/BackIcon.svg';
import ExportIcon from '../../../assets/Imagess/exportIcon.svg';
import PrintIcon from '../../../assets/Imagess/printIcon.svg';
import MoreButton from '../../Molecules/Custom/MoreButton';
import ReactToPrint from 'react-to-print';
import printicon from '../../../assets/Imagess/printIcon.svg';
import moment from 'moment';

function DetailsBox({ data, mode, setDetails, setMoveRight }) {
  const navigate = useNavigate();
  const menuItems = [
    {
      label: 'Export',
      icon: ExportIcon,
      // onClick: () => navigate("/home/programs/edit/11"),
    },
    {
      label: 'Print',
      icon: PrintIcon,
      onClick: () => {},
    },
  ];

  const [info, setInfo] = useState(null);
  const [selected, setSelected] = useState('onlineForm');
  let componentRef = useRef();

  const tabs = [
    {
      index: 0,
      name: 'onlineForm',
      text: 'Online Form',
      icon: FormIcon,
    },
  ];

  useEffect(() => {
    if (data) {
      let programInfo = [
        {
          Degree: data.degreeName_EN,
          Program: data.degreeType,
        },
      ];

      let personalInfo = [
        {
          First_Name: data.firstName,
          Last_Name: data.lastName,
          Email: data.email,
          Telephone: data.phoneNumber,
        },
        {
          Date_Of_birth: moment(data.dob).format('DD/MM/YYYY'),
          Gender: data.genderDisplay,
        },
      ];

      setInfo({
        fullName: data.firstName + ' ' + data.lastName,
        email: data.email,
        phone: data.phoneNumber,
        program: data.degreeName_EN,

        programInfo: programInfo,
        personalInfo: personalInfo,
      });
    }
  }, [data]);

  return (
    <>
      <div
        className={`${styles['parentContainer']}`}
        id={'PrintDetails'}
        ref={(el) => (componentRef = el)}
      >
        <div className={`${styles['major-box']} `}>
          <div className={`${styles['box-side']}`}>
            <img src={policeManIcon} className={` ${styles['leftImg']} `} />
          </div>
          <div className={`${styles['box-body']}`}>
            <h3>{info && info.fullName}</h3>
            {info && (
              <span className={styles['spanCont']}>
                {' '}
                <img src={emailIcon} />
                {info.email}
              </span>
            )}
            {info && (
              <span className={styles['spanCont']}>
                {' '}
                <img src={phoneIcon} />
                {info.phone}
              </span>
            )}
            <hr></hr>
            <h4>Program</h4>
            <span> {info && info.program}</span>
          </div>
        </div>

        {/* <table>
          <tr>
            <td>
              {" "}
              <h2
                className={styles["top-page"]}
                style={{ "font-family": "BukraLight" }}
              >
                Font Family Light
              </h2>
            </td>
          </tr>

          <tr>
            <td>
              {" "}
              <h2
                className={styles["top-page"]}
                style={{ "font-family": "BukraRegular" }}
              >
                Font Family Regular
              </h2>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <h2
                className={styles["top-page"]}
                style={{ "font-family": "BukraMedium" }}
              >
                Font Family Medium
              </h2>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <h2
                className={styles["top-page"]}
                style={{ "font-family": "BukraBold" }}
              >
                Font Family Bold
              </h2>
            </td>
          </tr>
        </table> */}

        <div
          className={`${styles['tab-select-container']} ${styles['row']}`}
          style={{ marginTop: '25px', marginBottom: '15px' }}
        >
          <div className={`${styles['tab-container']} ${styles['w-90']}`}>
            {tabs.map((tab) => (
              <ApplicantsTab
                key={tab.index}
                text={tab.text}
                icon={tab.icon}
                handleOnClick={() => {
                  setSelected(tab.name);
                }}
                active={tab.name === selected ? true : false}
                shadowed={false}
              />
            ))}
          </div>

          <div
            style={{ position: 'absolute', right: '40px', marginTop: '25px' }}
            className={`  ${styles['no-print']} `}
          >
            <MoreButton icon={moreInfo} top={1} right={30}>
              <div className={styles['in-container']}>
                {/* <div>
                  <div>
                    {" "}
                    <img src={ExportIcon} alt='profile' /> <span>Export</span>
                  </div>{" "}
                </div> */}
                <div>
                  <ReactToPrint
                    trigger={() => (
                      <div>
                        <img src={PrintIcon} alt="Details" />
                        <span>Print</span>
                      </div>
                    )}
                    content={() => componentRef}
                  />
                </div>
              </div>
            </MoreButton>
          </div>
        </div>

        <div className={`${styles['row']} `}>
          <InfoCard
            title="Personal Information"
            values={info && info.personalInfo}
            width={'w-49'}
            column={2}
          />
          <InfoCard
            title="Program Information"
            values={info && info.programInfo}
            width={'w-49'}
          />
        </div>
      </div>
    </>
  );
}

export default DetailsBox;
